module.exports = __webpack_public_path__ + "img/office.4ec4712e.jpg";